var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTxtItalic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.4 56.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XHlnJr"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.85.33Q14.94,28.62,10,56.9H.45C3.72,38,7,19.29,10.26.33Z",
    transform: "translate(-0.45 -0.33)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTxtItalic);
export default __webpack_public_path__ + "static/media/icon_txt_Italic.b68a0e7f7a71962faa53e612f7628087.svg";
export { ForwardRef as ReactComponent };